import { render, staticRenderFns } from "./ExchangeGift.vue?vue&type=template&id=a5b37a6c&scoped=true"
import script from "./ExchangeGift.vue?vue&type=script&lang=js"
export * from "./ExchangeGift.vue?vue&type=script&lang=js"
import style0 from "./ExchangeGift.vue?vue&type=style&index=0&id=a5b37a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b37a6c",
  null
  
)

export default component.exports